export const CITATION_SOURCES_CSV_FILENAME = 'citation-sources.csv'

const CITATION_SOURCES_CSV_HEADERS = [
  'Page AI cited',
  'URL',
  'Website',
  'Citations',
  'Source mentions you?',
  'Opportunity',
  'Last seen',
]

function escapeCsvValue(value) {
  if (value === null || value === undefined) {
    return ''
  }

  const stringValue = String(value)
  if (!/[",\r\n]/.test(stringValue)) {
    return stringValue
  }

  return `"${stringValue.replace(/"/g, '""')}"`
}

function cleanDate(value) {
  if (value === null || value === undefined) {
    return ''
  }
  return value.split('T')[0]
}

function cleanMentionStatusLabel(value) {
  if (value === null || value === undefined) {
    return ''
  }
  return String(value).replace(/^\u2022\s*/, '')
}

export function buildCitationSourcesCsv(rows = []) {
  const csvRows = [
    CITATION_SOURCES_CSV_HEADERS,
    ...rows.map(row => [
      row.citedPage?.title,
      row.citedPage?.url,
      row.website,
      row.citations?.value,
      cleanMentionStatusLabel(row.mentionStatus?.label),
      row.opportunity?.label,
      cleanDate(row.lastSeen),
    ]),
  ]

  return csvRows.map(row => row.map(escapeCsvValue).join(',')).join('\n')
}

export function downloadCsv(csv, fileName) {
  const csvFile = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
  const downloadLink = document.createElement('a')
  const url = window.URL.createObjectURL(csvFile)

  downloadLink.download = fileName
  downloadLink.href = url
  downloadLink.style.display = 'none'
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
  window.URL.revokeObjectURL(url)
}
